import React from 'react';
import { Container, Header, Input, Table } from 'semantic-ui-react';
import { Book } from '../Book/types';
import { db } from '../firebase';

const getCopiesAndAvailables = (books?: Book[]) => {
  let available = 0;
  let copies = 0;
  if (books) {
    books.forEach((book) => {
      available += book.available || 0;
      copies += book.copies || 0;
    });
  }
  return { available, copies };
};

export const Component = () => {
  const [books, setBooks] = React.useState<Book[]>();

  React.useEffect(() => {
    db.collection('books')
      .get()
      .then(function (querySnapshot) {
        const resp: Book[] = [];
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          const { id, name, copies, available } = doc.data();
          console.log(doc.id, ' => ', doc.data());
          resp.push({ id, name, copies, available });
        });
        setBooks(resp);
      });
  }, []);

  const handleAvailableChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    db.collection('books')
      .doc(e.target.id)
      .update({ available: parseInt(e.target.value) });
  };

  const handleCopiesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    db.collection('books')
      .doc(e.target.id)
      .update({ copies: parseInt(e.target.value) });
  };

  const { available, copies } = getCopiesAndAvailables(books);

  return (
    <Container>
      <Header>Book Inventory</Header>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Copies</Table.HeaderCell>
            <Table.HeaderCell>Available</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {books &&
            books.map((book) => (
              <Table.Row>
                <Table.Cell>{book.name}</Table.Cell>
                <Table.Cell>
                  <Input
                    id={book.id}
                    defaultValue={book.copies}
                    onBlur={handleCopiesChange}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Input
                    id={book.id}
                    defaultValue={book.available}
                    onBlur={handleAvailableChange}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell>{books?.length || 0} Books</Table.HeaderCell>
            <Table.HeaderCell>{copies} Copies</Table.HeaderCell>
            <Table.HeaderCell>{available} Available</Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </Container>
  );
};
